import { AfterViewInit, Directive, ElementRef, OnDestroy } from '@angular/core';
import { combineLatest, fromEvent, merge, Subscription } from 'rxjs';
import { map, mapTo, mergeMap, startWith } from 'rxjs/operators';

@Directive({
  selector: '[automaticNextCode]'
})
export class AutomaticNextCodeDirective implements AfterViewInit, OnDestroy {
  private inputs: HTMLElement[];
  private subscription: Subscription;

  constructor(private el: ElementRef) { }

  ngAfterViewInit() {
    this.inputs = this.el.nativeElement.children;
    const subscriptions = [];

    for (let i = 0; i < this.inputs.length; i++) {
      subscriptions.push(fromEvent(this.inputs[i], 'keyup').pipe(map(e => [e, i])));
    }

    this.subscription = merge(...subscriptions).subscribe(([event, index]) => {
      const input: any = this.inputs[index];
      
      if(event.key === 'Shift') {
        return;
      }

      if (isNaN(parseInt(event.key))) {
        event.stopPropagation();
        event.preventDefault();
        input.value = '';
        return;
      }

      input.value = event.key;

      if (index < this.inputs.length - 1) {
        this.inputs[index + 1].focus();
      }
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
